import RequestService from "@/services/v3/request.service";

/**
 * A cotação já passou por "Gerar Novos Pedidos" (/cotacoes/:id)? Esse fluxo
 * cria um `requests` (v2) com legacy_id = cot_id no kyojin; quem tem um deve
 * voltar para /cotacoes/:id e não para a tela de vencedores, que não enxerga os
 * pedidos gerados por lá.
 *
 * Só leitura (GET /v2/clients/requests/{cot_id}, nunca o /sync). Sem request o
 * kyojin responde erro ou id vazio: qualquer falha cai no fluxo de vencedores.
 */
export function has_v2_request(cot_id) {
    if (!cot_id) return Promise.resolve(false);

    return new RequestService()
        .load(cot_id)
        .then((response) => {
            const body = response && response.data;
            const request = body && body.data !== undefined ? body.data : body;
            return Boolean(request && request.id);
        })
        .catch(() => false);
}
